var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIconBrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 44,
    viewBox: "0 0 30 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0289 37.9834C21.0289 41.3204 18.2936 43.9899 14.9824 43.9899C11.6232 43.9899 8.93591 41.2727 8.93591 37.9834C8.93591 34.6465 11.6712 31.9769 14.9824 31.9769C18.3415 31.9769 21.0289 34.6465 21.0289 37.9834Z",
    fill: "#FF972F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7626 12.3842C28.6589 5.99632 23.6682 1.22926 17.0459 0.180506C10.9994 -0.820577 4.61699 2.42103 1.73772 7.95082C0.346067 10.6204 -0.325763 13.4329 0.154116 16.3885C0.490031 18.486 1.44979 20.3929 2.45753 22.252C4.85693 26.59 7.88017 30.4514 11.0954 34.2173C12.343 35.6475 13.6387 37.0776 14.9344 38.5077C15.2223 38.2217 15.4623 37.9833 15.6542 37.745C17.7177 35.3138 19.8771 32.9302 21.8926 30.4514C24.436 27.3051 26.7394 23.9682 28.467 20.2975C29.7147 17.771 30.2425 15.1968 29.7626 12.3842Z",
    fill: "#4F4949"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63256 15.1967C6.63256 13.8619 5.52884 12.7655 4.18518 12.7655V15.1967C4.18518 16.5315 5.2889 17.6279 6.63256 17.6279C7.97622 17.6279 9.07995 16.5315 9.07995 15.1967V12.7655C7.6883 12.7655 6.63256 13.8619 6.63256 15.1967Z",
    fill: "#FF972F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6124 12.7655C21.2688 12.7655 20.165 13.8619 20.165 15.1967V17.6279C21.5087 17.6279 22.6124 16.5315 22.6124 15.1967C22.6124 16.5315 23.7161 17.6279 25.0598 17.6279V15.1967C25.0598 13.8619 23.9561 12.7655 22.6124 12.7655Z",
    fill: "#FF972F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6139 12.7655H14.1665V17.6279H16.6139C17.9575 17.6279 19.0613 16.5315 19.0613 15.1967C19.0133 13.8619 17.9575 12.7655 16.6139 12.7655Z",
    fill: "#FF972F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3755 12.7655V15.1967C10.3755 16.5315 11.4792 17.6279 12.8229 17.6279V15.1967C12.8229 13.8619 11.7191 12.7655 10.3755 12.7655Z",
    fill: "#FF972F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIconBrown);
export default __webpack_public_path__ + "static/media/map-icon-brown.bc206b249a14f480ad73f725551346d8.svg";
export { ForwardRef as ReactComponent };